// src/services/utils/tokenUtils.js
// Pure utility functions for JWT parsing and cookie management (no store dependencies)

import Cookies from "js-cookie";

// Cookie configuration for refresh tokens
const REFRESH_TOKEN_COOKIE = "refresh_token";
const COOKIE_OPTIONS = {
  expires: 7, // 7 days
  // httpOnly: true, // Would be ideal but requires server-side implementation
};

/**
 * Parse JWT token payload
 * @param {string} token - JWT token
 * @returns {object|null} Parsed token payload or null if invalid
 */
export const parseJwt = (token) => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    const parsed = JSON.parse(jsonPayload);
    return parsed;
  } catch (error) {
    console.error("parseJwt - Error:", error);
    return null;
  }
};

/**
 * Secure cookie utilities for refresh tokens
 */
export const setRefreshTokenCookie = (token) => {
  if (token) {
    Cookies.set(REFRESH_TOKEN_COOKIE, token, COOKIE_OPTIONS);
  }
};

export const getRefreshTokenCookie = () => {
  return Cookies.get(REFRESH_TOKEN_COOKIE) || null;
};

export const clearRefreshTokenCookie = () => {
  Cookies.remove(REFRESH_TOKEN_COOKIE);
};
